module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMyAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjUgNy40Mjg1N1YxMUwxNS45NjM4IDE1LjQ2NDhNMjEuNSAxMUMyMS41IDE2LjUyMjggMTcuMDIyOCAyMSAxMS41IDIxQzUuOTc3MTUgMjEgMS41IDE2LjUyMjggMS41IDExQzEuNSA1LjQ3NzE1IDUuOTc3MTUgMSAxMS41IDFDMTcuMDIyOCAxIDIxLjUgNS40NzcxNSAyMS41IDExWiIgc3Ryb2tlPSIjMDA2MThCIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/v2/pinned-session.svg
// module id = 70G8
// module chunks = 0